import { Box, Card, CardProps, Skeleton, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { forwardRef } from "react"

export const HorizontalDirectorySkeletonCard = forwardRef<
  HTMLDivElement,
  CardProps
>(({ sx = {}, ...props }, ref) => {
  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`HorizontalDirectorySkeletonCard`] || {}
  const {
    root,
    avatar,
    cardContent,
    primaryText,
    secondaryText,
    venueSkeleton,
  } = styleOverrides
  return (
    <Card sx={deepmerge(root, sx)} ref={ref} {...props}>
      <Skeleton sx={avatar} variant="rectangular" />
      <Box sx={cardContent}>
        <Box>
          <Skeleton sx={primaryText} variant="text" width="80%" />
          <Skeleton sx={secondaryText} variant="text" width="60%" />
        </Box>
        <Skeleton sx={venueSkeleton} variant="text" width="60%" />
      </Box>
    </Card>
  )
})
